import { basename } from 'path';
import http from '../common/compornents/httpcommon';

class LoginServ {
  clickLogin = (companyCd: String, accountId: String, password: String) => {
    return http.post('Login/clickLogin/', {
      companyCd: companyCd,
      accountId: accountId,
      password: password,
    });
  };
  clickUpdate = (
    companyCd: String,
    accountId: String,
    password: String,
    changePass: String,
    confPass: String
  ) => {
    return http.post('Login/clickUpdate/', {
      companyCd: companyCd,
      accountId: accountId,
      password: password,
      changePass: changePass,
      confPass: confPass,
    });
  };
  clickSend = (companyCd: String, accountId: String, mailAdd: String) => {
    return http.post('Login/clickSend/', {
      companyCd: companyCd,
      accountId: accountId,
      mailAdd: mailAdd,
    });
  };
}
export default new LoginServ();
